import { lazy, type ComponentType } from "react";

type Props = { params?: { slug?: string } };
let loaded: ComponentType<Props> | undefined;
let loading: Promise<void> | undefined;
const LazyBlogPage = lazy(() => import("./pages/BlogPage"));

export function isBlogPath(path: string) {
  return /^\/blog(?:\/[^/]+)?\/?$/.test(path.split("?")[0]);
}

export function preloadBlogRoute(): Promise<void> {
  return loading ??= import("./pages/BlogPage").then(module => { loaded = module.default; });
}

export function BlogRoute(props: Props) {
  const Page = loaded ?? LazyBlogPage;
  return <Page {...props} />;
}
